import Home from "./components/Home";
import { AuthProvider } from "./contexts/AuthContext";
import GTM from "./components/GTM";
import GoogleAnalytics from "./components/GoogleAnalytics";
import BingUet from "./components/BingUet";
import { useEffect } from "react";
import { useAppContext } from "./contexts/AppContext";

export const Quoter = () => {
    const context = useAppContext();

    // TODO: Remove this from <Quoter />.
    // Let each installation handle their own loading of stylesheets, etc.
    // Create custom hook for this.
    useEffect(() => {
        if (!context) return;
        
        if (!context.contentPath) {
            document.body.classList.remove('hidden');
            return;
        }

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `${context.contentPath}/theme.css`;

        link.onload = () => {
            document.body.classList.remove('hidden');
        }

        document.head.appendChild(link);
        return () => {
            document.head.removeChild(link);
        };
    }, [context]);

    return (
        <>
            <GTM gtmId={context?.gtmContainerId} />
            <GoogleAnalytics />
            <BingUet />

            <AuthProvider>
                <Home />
            </AuthProvider>
        </>
    )
}